import Collapsible from "../Collapsible";
import CsvTable from "../CSVViewer";

const GeneHuntViewer = ({ type, id }) => {
  return (
    <div className="w-full flex flex-col gap-4">
      <Collapsible name="Overview Summary">
        <CsvTable
          csvUrl={`https://storage.kinggenomics.com/output/${type}/${id}/${
            type === "workflow" ? "combined_" : ""
          }overview_summary_output.csv`}
        />
      </Collapsible>
      <Collapsible name="Detailed Classification">
        <CsvTable
          csvUrl={`https://storage.kinggenomics.com/output/${type}/${id}/${
            type === "workflow" ? "combined_" : ""
          }detailed_classification_output.csv`}
        />
      </Collapsible>
      {type === "task" ? (
        <Collapsible name="Species Krona">
          <div className="w-full flex justify-end mt-5">
            <a
              href={`https://storage.kinggenomics.com/output/${type}/${id}/species_krona.html`}
              target="_blank"
              rel="noreferrer"
              className="text-blue-700 text-sm hover:underline cursor-pointer"
            >
              Open in a new tab
            </a>
          </div>
          <iframe
            src={`https://storage.kinggenomics.com/output/${type}/${id}/species_krona.html`}
            title="krona"
            frameBorder="0"
            className="w-full h-[600px] mb-5 p-3 bg-white rounded-sm shadow-sm"
          />
        </Collapsible>
      ) : null}
      <Collapsible name="Coverage By Reference">
        <CsvTable
          csvUrl={`https://storage.kinggenomics.com/output/${type}/${id}/${
            type === "workflow" ? "combined_" : ""
          }coverage_by_reference_FINAL.csv`}
        />
      </Collapsible>
      <Collapsible name="Reference Genome Alignment Summary">
        <CsvTable
          csvUrl={`https://storage.kinggenomics.com/output/${type}/${id}/${
            type === "workflow" ? "combined_" : ""
          }reference_genome_alignment_summary_FINAL.csv`}
        />
      </Collapsible>
      <Collapsible name="Gene Hits Report">
        <CsvTable
          csvUrl={`https://storage.kinggenomics.com/output/${type}/${id}/${
            type === "workflow" ? "combined_" : ""
          }gene_hits_report.csv`}
        />
      </Collapsible>
    </div>
  );
};

export default GeneHuntViewer;
